module.exports = __webpack_public_path__ + "static/img/logo.415562e.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/logo.png
// module id = 1XKl
// module chunks = 1